import validateForm_0 from "./0_validator";
import validateForm_1 from "./1_validator";

export default function validateForm (formType, invoiceData) {
    switch (formType) {
        case 0:
            return validateForm_0(invoiceData);
        case 1:
            return validateForm_1(invoiceData);
        default:
            return {};
    }
}